export enum StripeAction {
    REDIRECT = 'redirect_to_url',
    STRIPE_SDK = 'use_stripe_sdk',
    QR_CODE = 'display_qr_code',
    MICRO_DEPOSITS = 'verify_with_microdeposits',
}

export interface StripeConfirmResponse {
    redirectUrl: string;
    requiresAction?: boolean;
    clientSecret?: string;
    actionType?: StripeAction;
    qrCodeData?: string;
    qrCodeImagePNG?: string;
    qrCodeImageSVG?: string;
    qrCodeHostedInstructionsURL?: string;
}

export interface StripeConfirmResponseRaw {
    redirect_url: string;
    requires_action: boolean;
    payment_intent_client_secret: string;
    action_type: StripeAction;
    qr_code_data: string;
    qr_code_image_url_png: string;
    qr_code_image_url_svg: string;
    hosted_instructions_url: string;
}
